import { type GameTerms, type GameType } from '../../model'
import { GAME_BRACKET_TERM, GAME_BRACKET_TERM_MARKDOWN } from './bracket.terms'
import { GAME_LADDER_TERM, GAME_LADDER_TERM_MARKDOWN } from './ladder.terms'
import { GAME_RAFFLE_TERM } from './raffle.terms'

export function getDefaultTerms(gameType: GameType): GameTerms {
  switch (gameType) {
    case 'bracket':
      return GAME_BRACKET_TERM
    case 'raffle':
      return GAME_RAFFLE_TERM
    case 'ladder':
    default:
      return GAME_LADDER_TERM
  }
}

export function getDefaultTermsMarkdown(gameType: GameType): string {
  switch (gameType) {
    case 'bracket':
      return GAME_BRACKET_TERM_MARKDOWN
    case 'raffle':
      return GAME_RAFFLE_TERM
    case 'ladder':
    default:
      return GAME_LADDER_TERM_MARKDOWN
  }
}
